import React, {useState} from 'react'
import {Container, Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function Main() {
    const [actived, setActived] = useState(false)

    const toggle = i => {
        if(actived === i) {
           return setActived(null)
        }
        setActived(i)
    }
    return (
        <Container className="brand-page">
                    <h3>Brand</h3>
                    <input type="text" id="id_brand" name="brand" placeholder="Cari di Halaman Brand ..." />
                    <div className="urutan">
                        <h6>Urutkan</h6>
                        {
                            Urutan.map((data, i) => {
                                return (
                                    <button key={i} onClick={_ => toggle(i)} className={actived === i ? "active-button" : null} type="butuon">{data.nama}</button>
                                )
                            })
                        }
                        <div className="link-aphabet">
                            <Link to="#">Semua</Link>
                            {Alphabet.map((huruf, i) => {
                                return( <p key={i}>{huruf.huruf}</p> )
                            })}
                        </div>
                    </div>
                    <Row>
                    {
                        Images.map((img, i) => {
                            return (
                                <Col key={i} md={2.4}>
                                    <div className="cards">
                                        <img src={`${img.src + i}.png`} alt="cordova" />
                                        <footer>Cordova</footer>
                                    </div>
                                </Col>
                            )
                        })
                    }
                  </Row>
         
        </Container>
    )
}

const Urutan = [
    {nama:"Terpopuler"},
    {nama:"Nama A-Z"},
    {nama:"Nama A-Z"}
]

const Alphabet = [
    {huruf:"A"},{huruf:"B"},{huruf:"C"},{huruf:"D"},{huruf:"E"},{huruf:"F"},{huruf:"G"},{huruf:"H"},{huruf:"I"},{huruf:"J"},{huruf:"K"},{huruf:"L"},{huruf:"M"},{huruf:"N"},{huruf:"O"},{huruf:"P"},{huruf:"Q"},{huruf:"R"},{huruf:"S"},{huruf:"T"},{huruf:"U"},{huruf:"V"},{huruf:"W"},{huruf:"X"},{huruf:"Y"},{huruf:"Z"},{huruf:"#"}
]

const Images = [
    {src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"},{src:"asset/brand/cordova"}
]
